module.exports = __webpack_public_path__ + "img/andrew-pena-descanso-creek.e4591a5.jpg";